import { cva } from 'class-variance-authority';
export const getSpinnerClasses = cva('aspect-square shrink-0 animate-spin motion-reduce:animate-none rounded-full p-two', {
    variants: {
        color: {
            default: 'opacity-100',
            quiet: 'opacity-60',
            quieter: 'opacity-40',
            super: 'text-super-primary',
        },
    },
    defaultVariants: {
        color: 'default',
    },
});
//# sourceMappingURL=classes.js.map